<template>
  <v-dialog
    v-model="alertaComparte.estatus"
    max-width="420"
    width="90%"
  >
    <v-card class="cyg-dialog">
      <v-btn
        icon
        class="cyg-close"
        aria-label="Cerrar"
        @click="cerrarDialogo"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <div class="cyg-hero">
        <span class="cyg-overline">Recomendados</span>
        <h3 class="cyg-title">¡Comparte y gana!</h3>
        <div class="cyg-period">
          <v-icon small class="mr-1">mdi-calendar-range</v-icon>
          20 de agosto al 20 de septiembre
        </div>
      </div>

      <v-card-text class="pt-5 pb-2 px-5">
        <div class="cyg-section-label">Tarifas por folio</div>

        <div class="cyg-tarifa mb-3">
          <div class="cyg-tarifa-icon">
            <v-icon dark small>mdi-account-school</v-icon>
          </div>
          <div class="cyg-tarifa-copy">
            <div class="cyg-tarifa-name">Curso de Teens</div>
            <div class="cyg-tarifa-hint">Por cada folio</div>
          </div>
          <div class="cyg-tarifa-amount">$250</div>
        </div>

        <div class="cyg-tarifa mb-3">
          <div class="cyg-tarifa-icon">
            <v-icon dark small>mdi-laptop</v-icon>
          </div>
          <div class="cyg-tarifa-copy">
            <div class="cyg-tarifa-name">Online</div>
            <div class="cyg-tarifa-hint">Por cada folio</div>
          </div>
          <div class="cyg-tarifa-amount">$250</div>
        </div>

        <div class="cyg-tarifa">
          <div class="cyg-tarifa-icon">
            <v-icon dark small>mdi-account</v-icon>
          </div>
          <div class="cyg-tarifa-copy">
            <div class="cyg-tarifa-name">Curso de adultos</div>
            <div class="cyg-tarifa-hint">Por cada folio</div>
          </div>
          <div class="cyg-tarifa-amount">$500</div>
        </div>

        <p class="cyg-note mt-4 mb-0">
          Comparte tu enlace. Cuando tu recomendado se inscriba y liquide, verás la bonificación en Recomendados.
        </p>

        <v-alert
          v-if="copiado"
          dense
          text
          color="success"
          class="mb-0 mt-3"
        >
          No se abrió el menú de compartir. El enlace quedó copiado; pégalo en WhatsApp.
        </v-alert>
        <v-alert
          v-if="errorShare"
          dense
          text
          color="error"
          class="mb-0 mt-3"
        >
          {{ errorShare }}
        </v-alert>
      </v-card-text>

      <v-card-actions class="px-5 pb-5 pt-3 d-block">
        <v-btn
          block
          rounded
          dark
          large
          class="cyg-dialog-share text-none font-weight-bold"
          :loading="compartiendo"
          @click="compartirEnlace"
        >
          <v-icon left>mdi-share-variant</v-icon>
          Compartir
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { Clipboard } from '@capacitor/clipboard'
  import { sesionReferralDesdeGetters } from '@/referrals/sesion'

  export default {
    props: [
      'alertaComparte'
    ],

    data () {
      return {
        copiado: false,
        compartiendo: false,
        errorShare: '',
      }
    },

    computed: {
      ...mapGetters('login', [
        'getUsuarioLMS',
        'getEscuela',
        'getLogeadoLMS',
        'getDatosUsuarioLMS',
      ]),

      sesionReferral () {
        return sesionReferralDesdeGetters({
          logeado: this.getLogeadoLMS,
          usuario: this.getUsuarioLMS,
          datosUsuario: this.getDatosUsuarioLMS,
          escuela: this.getEscuela,
        })
      },
    },

    methods: {
      mensajeShare (shareUrl) {
        return [
          'Hola, ¿cómo estás? En la escuela de inglés donde estoy nos dieron la oportunidad de regalar unas becas y pensé en ti. 😎',
          '',
          'Solo mándales un mensaje por WhatsApp con mi link y te darán toda la info de horarios, precios y becas para que estudies inglés en INBI como yo. 👇',
          '',
          shareUrl,
          '',
          'Deja el mensaje que aparece al abrirlo para que sepan que vas recomendado por mí. 🙏',
        ].join('\n')
      },

      fueCancelado (error) {
        const msg = String((error && error.message) || error || '').toLowerCase()
        const name = String((error && error.name) || '')
        return name === 'AbortError'
          || msg.includes('cancel')
          || msg.includes('share canceled')
          || msg.includes('share cancelled')
      },

      async abrirShareNativo (mensaje) {
        try {
          const { Share } = await import('@capacitor/share')
          await Share.share({
            title: 'Comparte y gana',
            text: mensaje,
            dialogTitle: 'Compartir enlace',
          })
          return 'shared'
        } catch (e) {
          if (this.fueCancelado(e)) return 'cancelled'
        }
        if (typeof navigator !== 'undefined' && navigator.share) {
          try {
            await navigator.share({
              title: 'Comparte y gana',
              text: mensaje,
            })
            return 'shared'
          } catch (e) {
            if (this.fueCancelado(e)) return 'cancelled'
          }
        }
        return 'unavailable'
      },

      cerrarDialogo () {
        this.alertaComparte.estatus = false
        this.copiado = false
        this.errorShare = ''
      },

      async compartirEnlace () {
        if (!this.sesionReferral.ok) return

        this.errorShare = ''
        this.copiado = false
        this.compartiendo = true

        try {
          const response = await this.$http.post('api/referrals', {
            id_lms: this.sesionReferral.idLms,
          })
          const shareUrl = response.body && response.body.share_url
          if (!shareUrl) {
            throw new Error('No se recibió el enlace')
          }

          const mensaje = this.mensajeShare(shareUrl)
          const resultado = await this.abrirShareNativo(mensaje)
          if (resultado === 'shared') {
            this.cerrarDialogo()
            this.$emit('compartido')
            return
          }
          if (resultado === 'cancelled') return

          await Clipboard.write({ string: mensaje })
          this.copiado = true
        } catch (error) {
          const msg = (error && error.body && error.body.message)
            || (error && error.message)
            || 'No se pudo generar el enlace de recomendación.'
          this.errorShare = msg
        } finally {
          this.compartiendo = false
        }
      }
    }
  }
</script>

<style scoped>
  .cyg-dialog {
    overflow: hidden;
    border-radius: 20px !important;
  }

  .cyg-close {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 2;
    background: rgba(255, 255, 255, 0.92) !important;
  }

  .cyg-hero {
    padding: 28px 24px 20px;
    color: #fff;
    background: linear-gradient(135deg, #46CFFF 0%, #006093 100%);
  }

  .cyg-overline {
    display: block;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    opacity: 0.9;
    margin-bottom: 6px;
  }

  .cyg-title {
    margin: 0 0 12px;
    font-size: 1.45rem;
    font-weight: 800;
    letter-spacing: -0.02em;
    line-height: 1.2;
  }

  .cyg-period {
    display: inline-flex;
    align-items: center;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 999px;
    padding: 6px 12px;
    font-size: 13px;
    font-weight: 600;
  }

  .cyg-section-label {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #6b7280;
    margin-bottom: 12px;
  }

  .cyg-tarifa {
    display: flex;
    align-items: center;
    gap: 12px;
    background: #f5f8fb;
    border-radius: 14px;
    padding: 12px 14px;
  }

  .cyg-tarifa-icon {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    background: #006093;
  }

  .cyg-tarifa-copy {
    flex: 1;
    min-width: 0;
  }

  .cyg-tarifa-name {
    font-size: 14px;
    font-weight: 700;
    color: #0b3a6e;
    line-height: 1.25;
  }

  .cyg-tarifa-hint {
    font-size: 12px;
    color: #6b7280;
  }

  .cyg-tarifa-amount {
    font-size: 20px;
    font-weight: 800;
    color: #0b3a6e;
    letter-spacing: -0.4px;
  }

  .cyg-note {
    font-size: 12px;
    line-height: 1.45;
    color: #6b7280;
  }

  .cyg-dialog-share {
    background: linear-gradient(135deg, #006093 0%, #1ba3c9 100%) !important;
  }
</style>
